(function () {
  if (window.__bbSite) return;
  window.__bbSite = true;

  // ---- sliders: arrow buttons + mouse drag-to-scroll
  function initRails(scope) {
    (scope || document).querySelectorAll('[data-bb-rail-root]').forEach(function (root) {
      if (root.__bb) return;
      root.__bb = true;
      var rail = root.querySelector('[data-bb-rail]');
      if (!rail) return;
      root.querySelectorAll('[data-bb-rail-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          rail.scrollBy({ left: Number(b.dataset.bbRailDir) * rail.clientWidth * 0.8, behavior: 'smooth' });
        });
      });
      var d = { down: false, x: 0, left: 0, moved: false };
      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        d = { down: true, x: e.clientX, left: rail.scrollLeft, moved: false };
      });
      rail.addEventListener('pointermove', function (e) {
        if (!d.down) return;
        var dx = e.clientX - d.x;
        if (Math.abs(dx) > 4) { d.moved = true; rail.classList.add('is-drag'); }
        rail.scrollLeft = d.left - dx;
      });
      function end() { d.down = false; rail.classList.remove('is-drag'); }
      rail.addEventListener('pointerup', end);
      rail.addEventListener('pointerleave', end);
      rail.addEventListener('click', function (e) {
        if (d.moved) { e.preventDefault(); e.stopPropagation(); d.moved = false; }
      }, true);
    });
  }

  // ---- product card tilt (mouse only)
  var canTilt = window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)').matches;
  document.addEventListener('pointermove', function (e) {
    if (!canTilt || e.pointerType !== 'mouse') return;
    var card = e.target.closest && e.target.closest('[data-bb-card]');
    document.querySelectorAll('[data-bb-card].is-tilting').forEach(function (c) {
      if (c !== card) {
        c.classList.remove('is-tilting');
        c.style.setProperty('--rx', '0deg');
        c.style.setProperty('--ry', '0deg');
      }
    });
    if (!card) return;
    var r = card.getBoundingClientRect();
    var x = (e.clientX - r.left) / r.width;
    var y = (e.clientY - r.top) / r.height;
    card.style.setProperty('--ry', ((x - 0.5) * 12) + 'deg');
    card.style.setProperty('--rx', ((0.5 - y) * 12) + 'deg');
    card.style.setProperty('--gx', (x * 100) + '%');
    card.style.setProperty('--gy', (y * 100) + '%');
    card.classList.add('is-tilting');
  }, { passive: true });

  function boot() { initRails(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initRails(e.target); });
})();
